import React from 'react';
import { Message, Card, Input, Form, ToggleContainer, Counter, Section } from '@weezevent/nacre';
import { useTranslation, Trans } from 'react-i18next';
import Style from './settings.module.css';

export default function TicketOfficeInformationsForm({ ticketOfficeSettingsForm, setTicketOfficeSettingsForm, setTicketOfficeSettingsFormObject, formErrors }) {
    const { t } = useTranslation();

    const setQuotas = React.useCallback(
        checked => {
            if (!checked) {
                setTicketOfficeSettingsFormObject({ quota_set_default: false, quota_max_default: 0 }, true);
            } else {
                setTicketOfficeSettingsForm('quota_set_default', true);
            }
        },
        [setTicketOfficeSettingsForm]
    );

    return (
        <Card.FormStep
            title={t('ticket.ticket_offices.parameters.form.informations.title')}
            id="ticket-office-form-informations"
            rightComponent={
                <Message mini type="tips" title={t('ticket.common.tips')}>
                    <Trans i18nKey="ticket.ticket_offices.parameters.form.informations.message" />
                </Message>
            }
        >
            <Form.Field style={{ marginBottom: '0' }}>
                <Form.Label label={t('ticket.ticket_offices.parameters.form.informations.name_label')} required />
                <Input required value={ticketOfficeSettingsForm.name} onChange={(_, { value }) => setTicketOfficeSettingsForm('name', value)} error={t(formErrors['name'])} />
                <Form.FieldErrors errors={formErrors['name'] ? [t(formErrors['name'])] : null} />
                <ToggleContainer
                    className={Style['toogle_container_margin']}
                    checked={ticketOfficeSettingsForm.add_new_events}
                    tooltipProps={{ position: 'top' }}
                    title={t('ticket.ticket_offices.parameters.form.informations.add_new_event_label')}
                    helpLabel={t('ticket.ticket_offices.parameters.form.informations.add_new_event_helpLabel')}
                    onChange={(_, { checked }) => setTicketOfficeSettingsForm('add_new_events', checked)}
                />
                <ToggleContainer
                    className={Style['toogle_container_margin']}
                    checked={ticketOfficeSettingsForm.quota_set_default}
                    tooltipProps={{ position: 'top' }}
                    title={t('ticket.ticket_offices.parameters.form.informations.quota_set_label')}
                    inlinePosition="left"
                    helpLabel={t('ticket.ticket_offices.parameters.form.order.quotas_by_events_helpLabel')}
                    onChange={(_, { checked }) => setQuotas(checked)}
                />
                {ticketOfficeSettingsForm.quota_set_default && (
                    <Section>
                        <span>{t('ticket.ticket_offices.parameters.form.order.quotas_input_label')}</span>
                        <div className={Style['input_quota']}>
                            <Counter
                                min={0}
                                max={99999}
                                step={1}
                                numberDecimals={0}
                                value={ticketOfficeSettingsForm.quota_max_default}
                                onChange={(_, value) => setTicketOfficeSettingsForm('quota_max_default', value)}
                            />
                        </div>
                    </Section>
                )}
            </Form.Field>
        </Card.FormStep>
    );
}
